import { createStore } from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import ls from 'localstorage-slim';
import { description } from '@/const'

const agreeCookie = ls.get('agreeCookie')
const store = createStore({
  state() {
    return {
      loading: true,
      subscribe: true,
      modal: {
        isOpen: agreeCookie === null ? true : false,
      },
      category: [],
      productTypes: [
        {
          id: '84',
          name: '威士忌',
        },
        {
          id: '85',
          name: '葡萄酒',
        },
      ],
      menu: {
        header: {
          main: {
            menuIndex: -1,
            subMenuIndex: -1,
          },
          sub: {
            menuIndex: -1,
          },
        },
        sidebar: {
          isOpen: false,
          main: {
            menuIndex: -1,
            subMenuIndex: -1,
          },
          sub: {
            menuIndex: -1,
          }
        },
        search: {
          isOpen: false,
        },
      },
      breadcrumb: {
        items: [],
      },
      magazine: {},
      meta: {
        title: `《酒訊雜誌 Wine & Spirits Digest》`,
        og: {
          url: window.location.href,
          type: 'website',
          title: `《酒訊雜誌 Wine & Spirits Digest》`,
          description: description,
          image: 'https://drinker.s3.ap-northeast-1.amazonaws.com/logo.jpg',
        },
        meta: [
          {
            property: 'fb:app_id',
            content: 671097574106450,
          },
          {
            name: 'description',
            content: description,
          },
        ],
      },
    }
  },
  mutations,
  getters,
  actions,
})

export default store
